import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function NotificationBadge({ count }) {
  if (!count || count < 1) return null;
  return (
    <AnimatePresence>
      <motion.div
        className="absolute top-2 right-2 w-5 h-5 bg-gradient-to-tr from-red-500 to-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow-md ring-2 ring-white animate-pulse"
        initial={{ scale: 0.7, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.7, opacity: 0 }}
        transition={{ type: "spring", stiffness: 400, damping: 20 }}
      >
        {count}
      </motion.div>
    </AnimatePresence>
  );
}
